$.lui("comp",".comp_visual",(selector)=>{
    selector.on("click","[data-scroll]",function (e) {
        e.preventDefault();
        let next = $(this).closest(selector).next("section, div");
        if(next.length) {
            next.attr("data-lib-anchor-offset","#layout_header");
            next.anchor_anim(500);
        }
    })
});